import { AppIconButton } from "../../../../../../../shared/components/AppIconButton";
import { AppLoading } from "../../../../../../../shared/components/AppLoading";
import { FileIcon } from "../../../../../../../shared/icons/FileIcon";
import { PlusIcon } from "../../../../../../../shared/icons/PlusIcon";
import { DatabaseActions } from "../../../../../types";
import styles from "../styles.module.css";

interface Props {
  mode: DatabaseActions;
  actionsHandler: (type: DatabaseActions) => void;
  isStoreLoading: boolean;
}

export const AssistantDatabaseButton = (props: Props) => {
  const handleActionMode = () => {
    props.actionsHandler(props.mode);
  };

  if (props.isStoreLoading) {
    return <AppLoading settingSize={24} className={styles["loading"]} />;
  }

  return (
    <AppIconButton
      buttonType={"outlined"}
      onClick={handleActionMode}
      className={styles["database-button"]}
    >
      {props.mode === "create" ? <PlusIcon /> : <FileIcon />}
    </AppIconButton>
  );
};
